var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasStation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6474 6.76959L38.4274 8.42698L37.6474 9.69439H33.2602C32.453 9.69439 31.7979 9.03923 31.7979 8.23199C31.7979 7.42475 32.453 6.76959 33.2602 6.76959H37.6474Z",
    fill: "#384949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4218 21.3935V40.4047C46.4218 42.8235 44.4534 44.7919 42.0346 44.7919C39.6158 44.7919 37.6474 42.8235 37.6474 40.4047V31.6303C37.6474 30.824 36.9913 30.1679 36.185 30.1679H33.2602C32.453 30.1679 31.7979 29.5128 31.7979 28.7055C31.7979 27.8983 32.453 27.2431 33.2602 27.2431H36.185C38.6039 27.2431 40.5722 29.2115 40.5722 31.6303V40.4047C40.5722 41.211 41.2284 41.8671 42.0346 41.8671C42.8409 41.8671 43.497 41.211 43.497 40.4047V21.3935L44.9107 20.6136L46.4218 21.3935Z",
    fill: "#384949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7226 2.38238V49.3741H8.39941V2.38238C8.39941 1.57514 9.05457 0.919983 9.86181 0.919983H33.2602C34.0674 0.919983 34.7226 1.57514 34.7226 2.38238Z",
    fill: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7226 2.38238V49.3741H21.561V0.919983H33.2602C34.0675 0.919983 34.7226 1.57514 34.7226 2.38238Z",
    fill: "#E63950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3242 3.84479H31.7978V21.3936H11.3242V3.84479Z",
    fill: "#E6FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.561 3.84479H31.7978V21.3936H21.561V3.84479Z",
    fill: "#CCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5202 15.116L22.5954 18.0408H22.5945C22.3137 18.3216 21.9295 18.4688 21.561 18.4688C21.1662 18.4688 20.7889 18.3021 20.5276 18.0408H20.5266L17.6018 15.116C17.0315 14.5447 17.0315 13.6185 17.6018 13.0472C18.1731 12.4768 19.0993 12.4768 19.6706 13.0472L20.0986 13.4761V8.23199C20.0986 7.42475 20.7538 6.76959 21.561 6.76959C22.3683 6.76959 23.0234 7.42475 23.0234 8.23199V13.4761L23.4514 13.0472C24.0227 12.4768 24.9489 12.4768 25.5202 13.0472C26.0906 13.6185 26.0906 14.5447 25.5202 15.116Z",
    fill: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5202 15.116L22.5954 18.0408H22.5945C22.3137 18.3216 21.9296 18.4688 21.561 18.4688V6.76959C22.3683 6.76959 23.0234 7.42475 23.0234 8.23199V13.4761L23.4514 13.0472C24.0227 12.4768 24.9489 12.4768 25.5202 13.0472C26.0906 13.6185 26.0906 14.5447 25.5202 15.116Z",
    fill: "#E63950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6474 49.3741C37.6474 50.1813 36.9922 50.8365 36.185 50.8365H6.93701C6.12976 50.8365 5.47461 50.1813 5.47461 49.3741C5.47461 48.5668 6.12976 47.9117 6.93701 47.9117H36.185C36.9922 47.9117 37.6474 48.5668 37.6474 49.3741Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6474 49.3741C37.6474 50.1813 36.9923 50.8365 36.185 50.8365H21.561V47.9117H36.185C36.9923 47.9117 37.6474 48.5668 37.6474 49.3741Z",
    fill: "#384949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8275 30.8992C22.5457 30.4117 22.0534 30.1689 21.561 30.1689C21.0677 30.1689 20.5754 30.4127 20.2946 30.8992C18.18 34.8369 17.1738 35.5847 17.1738 37.48C17.1738 39.8988 19.1422 41.8671 21.561 41.8671C23.9798 41.8671 25.9482 39.8988 25.9482 37.48C25.9482 35.5847 24.9538 34.8584 22.8275 30.8992Z",
    fill: "#FED843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9482 37.48C25.9482 39.8988 23.9798 41.8671 21.561 41.8671V30.1689C22.0534 30.1689 22.5457 30.4117 22.8275 30.8992C24.9538 34.8584 25.9482 35.5847 25.9482 37.48Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9939 13.0472L40.1443 7.19759H40.1433C39.8742 6.92851 39.5018 6.76959 39.1099 6.76959H37.6475V17.0064C37.6475 19.4252 39.6158 21.3936 42.0347 21.3936H46.4218V14.0816C46.4218 13.6936 46.2678 13.3221 45.9939 13.0472Z",
    fill: "#E63950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.9165,
    height: 49.9165,
    fill: "white",
    transform: "translate(0.98999 0.919983)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStation);
export default __webpack_public_path__ + "static/media/gas-station.a53307a51918c2b01caf1b7bcae43b95.svg";
export { ForwardRef as ReactComponent };